import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-csr-reject',
  templateUrl: './csr-reject.component.html',
  styleUrls: ['./csr-reject.component.css'],
})
export class CsrRejectComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  private eventupdate = environment.url + environment.csrApproval;
  /**
   * Construct a new CsrRejectComponent.
   *
   * @param data The data injected into the dialog.
   * @param fb The form builder service.
   * @param makeapi The API service.
   * @param getdata The value service.
   * @param notify The notification service.
   * @param sanitizer The DOM sanitizer service.
   * @param dialogRef The reference to the dialog opened.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<CsrRejectComponent>
  ) {
    /**
     * The form group for the reason form.
     */
    this.reasonForm = this.fb.group({
      /**
       * The id of the CSR.
       */
      id: [''],
      /**
       * The status of the CSR.
       */
      status: [''],
      /**
       * The reason for rejecting the CSR.
       * Required.
       */
      reason: ['', [Validators.required]],
    });

    /**
     * Store the injected data in a local variable.
     */
    this.datas = data;

    /**
     * Set the default values for the form controls.
     */
    let getform = this.reasonForm.value;
    getform.id = this.datas._id; // Assign CSR ID from data
    getform.status = 2; // Set status to default 2
    this.reasonForm.patchValue(getform); // Update the form values
  }

  ngOnInit(): void {}
  get add() {
    return this.reasonForm.controls;
  }
  /**
   * Saves the rejection reason to the API.
   * Validates the form, constructs the request payload and sends it using the API service.
   * Closes the dialog and notifies success upon completion.
   */
  saveReason() {
    if (this.reasonForm.invalid) {
      // Mark all the form fields as touched to show validation errors
      this.reasonForm.markAllAsTouched();
      // Notify the user about the invalid form
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      // Construct the request payload
      const req = {
        id: this.datas._id,
        status: 2,
        remark: this.reasonForm.value.reason,
      };

      // Send the request to the API
      return this.makeapi
        .method(this.eventupdate, req, 'post')
        .subscribe((data) => {
          // Notify the user about the success
          this.notify.notifysuccess(data.responseMessage);
          // Close the dialog
          this.cancelReason();
          // Close the dialog
          this.dialogRef.close();
          // Reload the page
          window.location.reload();
        });
    }
  }
  /**
   * Closes the dialog without performing any action.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    // Reset the form fields
    this.reasonForm.reset();

    // Close the dialog
    this.dialogRef.close();
  }
}
